import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { SWATCH_ICON_TEST_ID_PREFIX } from "../constants.js";
import { containerCompactStyles, containerStyles } from "./styles.js";
const SwatchIcon = (props) => {
  const { productSwatch, variant } = props;
  const mergedStyles = {
    ...containerStyles,
    ...variant === "compact" ? containerCompactStyles : {},
    backgroundImage: `url(${productSwatch.swatchImageUrl})`
  };
  const swatchTestId = SWATCH_ICON_TEST_ID_PREFIX + productSwatch.attributeValue.replace(/\s+/g, "");
  return /* @__PURE__ */ jsx(Box, { "data-testid": swatchTestId, sx: mergedStyles });
};
export {
  SwatchIcon
};
